// extracted by mini-css-extract-plugin
export default {"tab-container":"Yf1UZ","tab-list":"NaOXv","tab-item":"ClAo8","active":"RNqcM"};